import { ApprovalInboxResponse } from "@/api/ApprovalInboxResponse";
import apiClient from "./core/ApiClient";

const fetchInbox = (): Promise<ApprovalInboxResponse> =>
  apiClient.get<ApprovalInboxResponse>("/api/approvals/inbox");

export const approvalInboxService = {
  fetchInbox,
};
